import { ErrorMessage, useField } from 'formik';
import React from 'react';
import { Form } from 'react-bootstrap';
import { FormLabel } from '../../forms';

interface DateFilterFieldProps {
  name: string;
  label?: string;
  isInvalid?: boolean;
  disabled?: boolean;
  max?: string;
  min?: string;
  defaultValue?: string;
  required?: boolean;
}

export const DateFilterField: React.FC<DateFilterFieldProps> = ({
  name,
  label,
  isInvalid,
  disabled,
  max,
  min,
  defaultValue,
  required
}) => {
  const [field, meta, helpers] = useField(name);

  const formatDateValue = (value: string) => {
    if (!value) return '';
    try {
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      return date.toISOString().split('T')[0];
    } catch {
      return value;
    }
  };

  return (
    <Form.Group
      controlId={name}
      className="w-100"
    >
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Form.Control
        type="date"
        max={max}
        min={min}
        disabled={disabled}
        isInvalid={isInvalid || (meta.touched && !!meta.error)}
        value={formatDateValue(field.value || defaultValue || '')}
        onChange={(e) => helpers.setValue(e.target.value)}
        onBlur={field.onBlur}
        aria-required={required || undefined}
      />
      <ErrorMessage
        name={name}
        component="span"
        className="text-danger fs-small"
      />
    </Form.Group>
  );
};
